function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children"],
  _excluded2 = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
// packages/react/slot/src/Slot.tsx
import * as React from "react";
import { composeRefs } from "@radix-ui/react-compose-refs";
import { Fragment, jsx } from "react/jsx-runtime";
var Slot = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    slotProps = _objectWithoutProperties(props, _excluded);
  var childrenArray = React.Children.toArray(children);
  var slottable = childrenArray.find(isSlottable);
  if (slottable) {
    var newElement = slottable.props.children;
    var newChildren = childrenArray.map(function (child) {
      if (child === slottable) {
        if (React.Children.count(newElement) > 1) return React.Children.only(null);
        return /*#__PURE__*/React.isValidElement(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /* @__PURE__ */jsx(SlotClone, _objectSpread(_objectSpread({}, slotProps), {}, {
      ref: forwardedRef,
      children: /*#__PURE__*/React.isValidElement(newElement) ? /*#__PURE__*/React.cloneElement(newElement, void 0, newChildren) : null
    }));
  }
  return /* @__PURE__ */jsx(SlotClone, _objectSpread(_objectSpread({}, slotProps), {}, {
    ref: forwardedRef,
    children: children
  }));
});
Slot.displayName = "Slot";
var SlotClone = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    slotProps = _objectWithoutProperties(props, _excluded2);
  if (/*#__PURE__*/React.isValidElement(children)) {
    var childrenRef = getElementRef(children);
    return /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, mergeProps(slotProps, children.props)), {}, {
      // @ts-ignore
      ref: forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef
    }));
  }
  return React.Children.count(children) > 1 ? React.Children.only(null) : null;
});
SlotClone.displayName = "SlotClone";
var Slottable = function Slottable(_ref) {
  var children = _ref.children;
  return /* @__PURE__ */jsx(Fragment, {
    children: children
  });
};
function isSlottable(child) {
  return /*#__PURE__*/React.isValidElement(child) && child.type === Slottable;
}
function mergeProps(slotProps, childProps) {
  var overrideProps = _objectSpread({}, childProps);
  var _loop = function _loop() {
    var slotPropValue = slotProps[propName];
    var childPropValue = childProps[propName];
    var isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = function () {
          childPropValue.apply(void 0, arguments);
          slotPropValue.apply(void 0, arguments);
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = _objectSpread(_objectSpread({}, slotPropValue), childPropValue);
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  };
  for (var propName in childProps) {
    _loop();
  }
  return _objectSpread(_objectSpread({}, slotProps), overrideProps);
}
function getElementRef(element) {
  var _Object$getOwnPropert, _Object$getOwnPropert2;
  var getter = (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.get;
  var mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_Object$getOwnPropert2 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object$getOwnPropert2 === void 0 ? void 0 : _Object$getOwnPropert2.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var Root = Slot;
export { Root, Slot, Slottable };